
<template>
  <div>
    <v-dialog v-model="dialog" scrollable  persistent max-width="1000px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title class="d-flex align-center justify-space-between">
          <div class="headline mb-0">Detalhes do pagamento</div>
          <DialogOrdersPayedBySource v-if="data?.data?.attributes?.payment_id || data?.data?.attributes?.payment?.id" :payment_id="data?.data?.attributes?.payment_id || data?.data?.attributes?.payment?.id"></DialogOrdersPayedBySource>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="info" :value="true" v-if="loading">
            Carregando...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <div v-if="!loading">
            <bill-detail    :item="data" v-if="item.class == 'bill'"></bill-detail>
            <cash-detail    :item="data" v-if="item.class == 'cash'"></cash-detail>
            <pay-devolution-detail    :item="data" v-if="item.class == 'pay_devolution'"></pay-devolution-detail>
            <check-detail   :item="data" v-if="item.class == 'check'"></check-detail>
            <deposit-detail :item="data" v-if="item.class == 'deposit'"></deposit-detail>
            <pix-detail     :item="data" v-if="item.class == 'pix'"></pix-detail>
            <bonus-detail     :item="data" v-if="item.class == 'bonus'"></bonus-detail>
            <exchange-detail :item="data" v-if="item.class == 'exchange'"></exchange-detail>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <!-- <v-btn text color="error">Cancelar</v-btn> -->
          <f-btn close @click="dialog = false"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BillDetail from '@/_backoffice/_registrations/components/client/payment_detail/bill/BillDetail.vue'
import CashDetail from '@/_backoffice/_registrations/components/client/payment_detail/CashDetail.vue'
import PayDevolutionDetail from '@/_backoffice/_registrations/components/client/payment_detail/PayDevolutionDetail.vue'
import CheckDetail from '@/_backoffice/_registrations/components/client/payment_detail/check/CheckDetail.vue'
import DepositDetail from '@/_backoffice/_registrations/components/client/payment_detail/deposit/DepositDetail.vue'
import PixDetail from '@/_backoffice/_registrations/components/client/payment_detail/PixDetail.vue'
import BonusDetail from '@/_backoffice/_registrations/components/client/payment_detail/BonusDetail.vue'
import ExchangeDetail from '@/_backoffice/_registrations/components/client/payment_detail/ExchangeDetail.vue'
import Api from '@/api/index';

export default {
  name: 'DialogPaymentDetails',
  components: {
    BillDetail,
    CashDetail,
    PayDevolutionDetail,
    PixDetail,
    BonusDetail,
    DepositDetail,
    CheckDetail,
    ExchangeDetail,
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: true,
      loading: false,
      data: {},
    }
  },
  methods: {
    getData() {
      if (this.item.id && this.item.class){
        const ACTION_MAP = {
          bill: 'Bill',
          cash: 'Cash',
          pay_devolution: 'PayDevolution',
          deposit: 'Deposit',
          check: 'Check',
          pix: 'Pix',
          exchange: 'Exchange',
          bonus: 'Bonus',
        }
        this.loading = true
        Api[ACTION_MAP[this.item.class]].show(this.item.id).then(r=>r.data).then(d=>{
          this.data = {...d, extras: {...this.item}}
        }).catch((err) => {
          console.log(err);
        }).finally(()=>{
          this.loading = false
        })
      } else {
        this.dialog = false
      }
    },
  },
  mounted () {
    this.getData();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
      } else if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>
